module.exports = __webpack_public_path__ + "static/media/restroom.73f4deda.svg";